// extracted by mini-css-extract-plugin
export default {"main":"root_main__PjGa2"};